import './App.css';
import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom'
import { createBrowserHistory } from 'history';
import Home from './Containers/Home'
import Main from './Containers/Main'
import NavBar from './Components/NavBar'
import List from './Components/List'
import Footer from './Components/Footer'

import ProjGame from "./Components/Proj/design/Proj_Game"
import ProjPaperModel from "./Components/Proj/design/Proj_PaperModel"
import ProjFourier from "./Components/Proj/design/Proj_Fourier"
import ProjFlake from "./Components/Proj/design/Proj_Flake"
import ProjTexel from './Components/Proj/hci/Proj_Texel'
import ProjCar from './Components/Proj/tech/Proj_Car'
import ProjBIT from './Components/Proj/tech/Proj_BIT'
import ProjAshore from './Components/Proj/tech/Proj_Ashore'
import ProjJapanTravel from './Components/Proj/illust/Proj_japantravel'
import ProjFood from './Components/Proj/illust/Proj_Food'
import ProjBerlinTravel from './Components/Proj/illust/Proj_BerlinTravel'
import ProjSplat from './Components/Proj/web/Proj_Splat'
import ProjTed from './Components/Proj/web/Proj_ted'
import ProjCreative from './Components/Proj/web/Proj_Creative'

var history = createBrowserHistory();


const project_categories_links = ['hci-texel',
'tech-EECSCapstone','tech-CSLlab','tech-speaker',
'design-gamecontroller','design-papermodel','design-lighting','design-chair',
'web-tedx','web-humancenterdesign','web-splat',
'illust-food','illust-japan','illust-berlin'//,'illust-daily'
]

const path = {
  'hci-texel': <ProjTexel/>,
  'tech-EECSCapstone': <ProjCar />,
  'tech-CSLlab': <ProjBIT />,
  'tech-speaker': <ProjAshore />,
  'design-gamecontroller': <ProjGame/>,
  'design-papermodel': <ProjPaperModel/>,
  'design-lighting': <ProjFourier/>,
  'design-chair': <ProjFlake/>,
  'web-tedx':<ProjTed />,
  'web-humancenterdesign': <ProjCreative />,
  'web-splat': <ProjSplat/>,
  'illust-food': <ProjFood/>,
  'illust-japan': <ProjJapanTravel />,
  'illust-berlin': <ProjBerlinTravel/>
  //'illust-daily': <ProjLife />,
}



function App() {
  return (
    <div className="App">
      <Switch>
        <Route exact path="/" render={()=><Home />} history={history} />
        <Route path="/hi" render={()=><Main />} history={history} />
        <Route path="/projects"> <Redirect to="/hi" /> </Route>
        {
            project_categories_links.map( e =>
                <Route path={`/${e}`} render={() => {
                  return (
                    <div className="container">
                        <NavBar />
                        <div className="list">
                            <List />
                        </div>
                        <div className="content"> 
                          {path[e]}
                        </div>
                    </div>
                  )
                }}/>
            )
        }
      </Switch>
    </div>
  );
}


export default App;
